module.exports = __webpack_public_path__ + "2c4c587045d61c4578b8acbe8f00e423.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/invesco.png
// module id = 1685
// module chunks = 0